import { render, staticRenderFns } from "./LadderSchemeItem.vue?vue&type=template&id=f4a92e68&scoped=true"
import script from "./LadderSchemeItem.vue?vue&type=script&lang=js"
export * from "./LadderSchemeItem.vue?vue&type=script&lang=js"
import style0 from "./LadderSchemeItem.vue?vue&type=style&index=0&id=f4a92e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a92e68",
  null
  
)

export default component.exports